/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Do note that a service worker doesn't work in private mode!
if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () { /* Do nothing */ },
    registered () { /* Do nothing */ },
    cached () { /* Do nothing */ },
    async updatefound () {
      if (navigator.serviceWorker.controller) {
        const installingWorker = await navigator.serviceWorker.getRegistration()
        if (installingWorker === null || typeof installingWorker === 'undefined') {
          return
        }

        const serviceWorker = installingWorker.installing
        if (serviceWorker) {
          serviceWorker.onstatechange = () => {
            switch (serviceWorker.state) {
              case 'installed':
                break
              case 'redundant':
                throw new Error('The installing service worker became redundant')
              default:
                // Do nothing
            }
          }
        }
      }
    },
    updated () { /* Do nothing */ },
    offline () { /* Do nothing */ },
    error () { /* Do nothing */ }
  })
}
